module.exports = __webpack_public_path__ + "static/media/pending.b2931380.svg";